if ($('#app-form-post-edit-comscore').length) {
    show_loader();
    var playback_types = {
        'LPM': {
            'LO': 'Live Only',
            'LS': 'Live Plus Same Day',
            'L3': 'Live Plus 3',
            'L7': 'Live Plus 7'
        },
        'SRM': {
            'LS': 'Live Plus Same Day',
            'L3': 'Live Plus 3',
            'L7': 'Live Plus 7'
        },
        'CRM': {
            'LS': 'Live Plus Same Day',
            'L3': 'Live Plus 3',
            'L7': 'Live Plus 7'
        },
        'DIA': {
            'L1': 'Live Plus 1'
        }
    };
    var playback_types_all = {
        'LO': 'Live Only',
    };
    $('#advertiser').select2({
        placeholder: "Select one...",
        minimumResultsForSearch: 5
    });
    $('#campaign').select2({
        placeholder: "Select one...",
        minimumResultsForSearch: 5
    });
    $('#market').select2({
        placeholder: "Select one...",
        minimumResultsForSearch: 5
    });
    $('#stations').multiSelect({
        selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
        selectionHeader: '<div style="height: 38px;"><input type="button" style="font-size: 10px; padding: 3px" class="btn btn-info btn-outline m-r-5 btn-sm " value="Select All" id="select_all_station">&nbsp;'+ "<input style='font-size: 10px; padding: 3px' type='button' class='btn btn-info btn-outline m-r-5 btn-sm ' value='Deselect All' id='deselect_all_station'>" +'</div>',
        afterInit: function(ms){
            var that = this,
                $selectableSearch = that.$selectableUl.prev(),
                selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

            that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                .on('keydown', function(e){
                    if (e.which === 40){
                        that.$selectableUl.focus();
                        return false;
                    }
                });
        },
        afterSelect: function(values){su
            this.qs1.cache();
        },
        afterDeselect: function(values){
            this.qs1.cache();
        }
    });
    $('.div_stations ').on('click','#select_all_station', function () {
        $('#stations').multiSelect('select_all');
    })
    $('.div_stations').on('click', '#deselect_all_station',function () {
        $('#stations').multiSelect('deselect_all');
    })
    $('#year').select2({
        placeholder: "Select one...",
        minimumResultsForSearch: 5
    });
    $('#data_stream').select2({
        placeholder: "Select one...",
        minimumResultsForSearch: 5
    });
    $('#book_type').select2({
        placeholder: "Select one...",
        minimumResultsForSearch: 5
    });
    $('#book').select2({
        placeholder: "Select one...",
        minimumResultsForSearch: 5
    });
    // var html_year='<option></option>';
    // for (var i = new Date().getFullYear(); i>=new Date().getFullYear()-4; i--){
    //     if(i < 2019) {
    //         var selected='';
    //         if(report.year== i)
    //             selected='selected';
    //         html_year += '<option value="' + (i) + '" '+selected+'>' + (i) + '</option>';
    //     }
    // }
    // $('#year').html(html_year);
    if($('#book_type option:selected').val() === 'quarter')
        var options = '<option value="">Select a Range</option><option value="01-01">January - March</option><option value="04-01">April - June</option><option value="07-01">July - September</option><option value="10-01">October - December</option>';
    else
        var options = '<option value="">Select a Month</option><option value="01-01">January</option><option value="02-01">Febrary</option><option value="03-01">March</option><option value="04-01">April</option><option value="05-01">May</option><option value="06-01">June</option><option value="07-01">July</option><option value="08-01">August</option><option value="09-01">September</option><option value="10-01">October</option><option value="11-01">November</option><option value="12-01">December</option>';
    $('#book').append(options);

    $('#book option').each( function () {
        if($(this).val()==report.book)
            $(this).attr('selected', true);
    });
    $('#name').val(report.name);

    $('#invoices').multiSelect({
        selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
        selectionHeader: '<div style="height: 38px;"><input type="button" style="font-size: 10px; padding: 3px" class="btn btn-info btn-outline m-r-5 btn-sm " value="Select All" id="select_all_invoices">&nbsp;'+ "<input style='font-size: 10px; padding: 3px' type='button' class='btn btn-info btn-outline m-r-5 btn-sm ' value='Deselect All' id='deselect_all_invoices'>" +'</div>',
        afterInit: function(ms){
            var that = this,
                $selectableSearch = that.$selectableUl.prev(),
                selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

            that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                .on('keydown', function(e){
                    if (e.which === 40){
                        that.$selectableUl.focus();
                        return false;
                    }
                });
        },
        afterSelect: function(values){
            this.qs1.cache();
        },
        afterDeselect: function(values){
            this.qs1.cache();
        }
    });
    $('.div_invoices').on('click', '#select_all_invoices',function () {
        $('#invoices').multiSelect('select_all');
    })
    $('.div_invoices').on('click', '#deselect_all_invoices',function () {
        $('#invoices').multiSelect('deselect_all');
    })
    var adv_id= report.advertiser_id
    if(typeof adv_id!=='undefined' && adv_id!=''){
        show_loader();
        $.ajax({
            type: 'GET',
            url: '/post/getCampaigns/' + adv_id,
            dataType: 'json',
            encode: true,
            success: function (data) {
                var html='<option></option>';
                for(var i in data) {
                    var selected='';
                    if(report.campaign_id == data[i].id)
                        selected='selected';
                    html += '<option start="'+ data[i].start +'" end="'+ data[i].end +'" value="' + data[i].id + '" '+selected+'>' + data[i].name + '</option>';
                }
                $('#campaign').html(html);
                hide_loader();
                var camp_id=$('#campaign option:selected').val();

                if(typeof camp_id!=='undefined' && camp_id!=''){
                    show_loader();
                    $('.books_help').hide();
                    $.ajax({
                        type: 'GET',
                        url: '/post/comscore/campaign/getMarkets/' + camp_id,
                        dataType: 'json',
                        encode: true,
                        success: function (response) {
                            var data=response.markets;
                            console.log('response.markets ....', data);
                            $('.demo_help').html('');
                            $('.demo_help').html('<span style="color: silver; ">'+response.demos+'</span>');
                            $('.demo_help').show();
                            var html='<option></option>';
                            for(var i in data) {
                                var selected = parseInt(report.market_code) === parseInt(data[i].code) && data[i].type === report.type ? 'selected' : '';
                                html += '<option value="' + data[i].code + '" data-type="' + data[i].type + '" '+selected+'>' + data[i].type.toUpperCase() + '- ' + data[i].market_name + '</option>';
                            }
                            $('#market').html(html);
                            var htmltoadd = ""
                            var nowTime = (parseInt(moment($('#campaign option:selected').attr("end")).format("YYYY")) < parseInt(moment().format("YYYY"))) ? parseInt(moment($('#campaign option:selected').attr("end")).format("YYYY")) : parseInt(moment().format("YYYY"))
                            var gtrTime = parseInt(moment($('#campaign option:selected').attr("start")).format("YYYY"))
                            while(nowTime >= gtrTime){
                                var selected = (nowTime == report.year) ? "selected" : ""
                                htmltoadd += '<option value="' + nowTime +'" ' + selected + '>' + nowTime + '</option>';
                                nowTime--
                            }
                            $("#year").html(htmltoadd).select2()
                            hide_loader();
                            var camp_id= $('#campaign option:selected').val();
                            var market_code= $('#market option:selected').val();
                            if(typeof camp_id!=='undefined' && camp_id!='' && typeof market_code!=='undefined' && market_code!=''){
                                $.ajax({
                                    type: 'GET',
                                    url: '/post/comscore/campaign/market/getStations/' + camp_id+'/'+ market_code,
                                    dataType: 'json',
                                    encode: true,
                                    success: function (response) {
                                        var data= response.stations;
                                        $('.books_help').html('');
                                        $('.books_help').html('<span style="color: silver; ">'+response.books+'</span>');
                                        $('.books_help').show();
                                        var html='';
                                        var sta = [];
                                        console.log('report.stations ----- report.stations', report.stations);
                                        for(var x in report.stations)
                                            sta.push(parseInt(report.stations[x]));
                                        console.log('report.stations ----- sta', sta);
                                        for(var i in data) {
                                            var selected='';
                                            if(sta.indexOf(parseInt(data[i].id)) !== -1)
                                                selected = 'selected';
                                            console.log('---- ', data[i].id, sta.indexOf(parseInt(data[i].id)));
                                            html += '<option value="' + data[i].id + '" '+selected+'>' + data[i].name + '</option>';
                                        }
                                        $('#stations').html(html).multiSelect('refresh');

                                        $('#invoices').html('').multiSelect('refresh');
                                        if($('#stations').val().length > 0){
                                            show_loader();
                                            var params = {
                                                campaign: $('#campaign option:selected').val(),
                                                market: $('#market option:selected').val(),
                                                stations: $('#stations').val(),
                                            };
                                            $.ajax({
                                                type: 'POST',
                                                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                                                data: JSON.stringify(params),
                                                url: '/post/comscore/campaign/market/station/getInvoices',
                                                dataType: "json",
                                                contentType: "application/json",
                                                success: function (response) {
                                                    var html='';
                                                    console.log(response);
                                                    console.log(report.invoices);
                                                    var sta = [];
                                                     sta = {imported:[], manual:[]};
                                                    for(var m in report.invoices) {
                                                        for(var x in report.invoices[m])
                                                           sta[m].push(parseInt(report.invoices[m][x]));
                                                    }
                                                    console.log('sta.... invoices', sta);
                                                    for (var i in response) {
                                                        var selected='';
                                                        if(response[i].type=='Imported')
                                                            var xx='imported';
                                                        else
                                                            var xx='manual';
                                                        if( sta[xx].indexOf(response[i].id) !== -1)
                                                            selected='selected';
                                                        console.log(xx);
                                                        console.log(sta[xx].indexOf(response[i].id));
                                                        html += '<option value="' + response[i].type + '_' + response[i].id + '" '+selected+'>' + response[i].number + '  (' + response[i].type + ')</option>';
                                                    }
                                                    $('#invoices').html(html).multiSelect('refresh');
                                                    hide_loader();
                                                },
                                                error: function (xhr) {
                                                    hide_loader();
                                                    ajax_error();
                                                    debug(xhr.responseText);
                                                }
                                            });
                                        }
                                    },
                                    error: function (xhr) {
                                        hide_loader();
                                        ajax_error();
                                        debug(xhr.responseText);
                                    }
                                });
                            }
                        },
                        error: function (xhr) {
                            hide_loader();
                            ajax_error();
                            debug(xhr.responseText);
                        }
                    });
                }
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);
            }
        });
    }
    hide_loader();


    $('#book_type').on('change', function () {
        $('#book').html('');
        if($('#book_type option:selected').val() === 'quarter')
            var options = '<option value="">Select a Range</option><option value="01-01">January - March</option><option value="04-01">April - June</option><option value="07-01">July - September</option><option value="10-01">October - December</option>';
        else
            var options = '<option value="">Select a Month</option><option value="01-01">January</option><option value="02-01">Febrary</option><option value="03-01">March</option><option value="04-01">April</option><option value="05-01">May</option><option value="06-01">June</option><option value="07-01">July</option><option value="08-01">August</option><option value="09-01">September</option><option value="10-01">October</option><option value="11-01">November</option><option value="12-01">December</option>';
        $('#book').append(options);
        $('#book option').each( function () {
            if($(this).val()==report.book)
                $(this).attr('selected', true);
        });
    });
    $('#advertiser').on('change', function () {
        $('#campaign').html('');
        $('#market').html('');
        $('#stations').html('').multiSelect('refresh');
        $('#start').html('');
        $('#end').html('');
        $('#invoices').html('').multiSelect('refresh');
        $('#general_books_div').hide();
        $('#div_geography').hide();
        $('.demo_help').hide();
        $('.books_help').hide();
        $('#div_books_empty').show();
        $('#form_secondary_demos').html('');
        global_campaign_demos = '';
        var adv_id= $('#advertiser option:selected').val();
        if(typeof adv_id!=='undefined' && adv_id!=''){
            show_loader();
            $.ajax({
                type: 'GET',
                url: '/post/getCampaigns/' + adv_id,
                dataType: 'json',
                encode: true,
                success: function (data) {
                    var html='<option></option>';
                    for(var i in data)
                        html+='<option value="'+data[i].id +'">'+data[i].name +'</option>';
                    $('#campaign').html(html);
                    hide_loader();
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);
                }
            });
        }
    });
    $('#campaign').on('change', function () {
        $('#market').html('');
        $('#stations').html('').multiSelect('refresh');
        $('#invoices').html('').multiSelect('refresh');
        var camp_id= $('#campaign option:selected').val();
        if(typeof camp_id!=='undefined' && camp_id!=''){
            show_loader();
            $('.books_help').hide();
            $.ajax({
                type: 'GET',
                url: '/post/comscore/campaign/getMarkets/' + camp_id,
                dataType: 'json',
                encode: true,
                success: function (response) {
                    var data=response.markets;
                    console.log('data ***', data);
                    $('.demo_help').html('');
                    $('.demo_help').html('<span style="color: silver; ">'+response.demos+'</span>');
                    $('.demo_help').show();
                    var html='<option></option>';
                    for(var i in data)
                        html+='<option value="'+data[i].code +'" >'+data[i].name +'</option>';
                    $('#market').html(html);
                    global_campaign_demos = response.campaign_demos;
                    $('#form_secondary_demos').select2({
                        placeholder: "Select one...",
                        minimumResultsForSearch: 5
                    }).html('');
                    hide_loader();
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);
                }
            });
        }
        else {
            $('.demo_help').hide();
            $('.books_help').hide();
        }

    });
    $('#market').on('change', function () {
        $('#stations').html('').multiSelect('refresh');
        $('#invoices').html('').multiSelect('refresh');
        var htmltoadd = ""
        var nowTime = (parseInt(moment($('#market option:selected').data("end")).format("YYYY")) < parseInt(moment().format("YYYY"))) ? parseInt(moment($('#market option:selected').data("end")).format("YYYY")) : parseInt(moment().format("YYYY"))
        var gtrTime = parseInt(moment($('#market option:selected').data("start")).format("YYYY"))
        while(nowTime >= gtrTime){
            htmltoadd += '<option value="' + nowTime +'">' + nowTime + '</option>';
            nowTime--
        }
        $("#year").html(htmltoadd).select2()
        var camp_id= $('#campaign option:selected').val();
        var market_code= $('#market option:selected').val();
        var v_type = $('#market option:selected').attr('data-type');
        var html_d = '';
        if(typeof global_campaign_demos[v_type] !== 'undefined') {
            for (var i in global_campaign_demos[v_type])
                html_d += '<option value="' + global_campaign_demos[v_type][i].id + '">' + global_campaign_demos[v_type][i].demo_name + '</option>';
        }
        $('#form_secondary_demos').select2({
            placeholder: "Select one...",
            minimumResultsForSearch: 5
        }).html(html_d);

        if(typeof camp_id!=='undefined' && camp_id!='' && typeof market_code!=='undefined' && market_code!=''){
            $.ajax({
                type: 'GET',
                url: '/post/comscore/campaign/market/getStations/' + camp_id+'/'+ market_code,
                dataType: 'json',
                encode: true,
                success: function (response) {
                    console.log('stations');
                    console.log(response);
                    var data= response.stations;
                    $('.books_help').html('');
                    $('.books_help').html('<span style="color: silver; ">'+response.books+'</span>');
                    $('.books_help').show();
                    var html='';
                    for(var i in data)
                        html+='<option value="'+data[i].id +'" >'+data[i].name +'</option>';
                    $('#stations').html(html).multiSelect('refresh');
                    hide_loader();
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);
                }
            });
        }

    });
    $('#stations').on('change', function () {
        $('#invoices').html('').multiSelect('refresh');
        if($('#stations').val().length > 0){
            show_loader();
            var params = {
                campaign: $('#campaign option:selected').val(),
                market: $('#market option:selected').val(),
                stations: $('#stations').val(),
            };
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: '/post/comscore/campaign/market/station/getInvoices',
                dataType: "json",
                contentType: "application/json",
                success: function (response) {
                    var html='';
                    for (var i in response)
                        html+='<option value="'+response[i].type+'_'+response[i].id+'">'+response[i].number+'  ('+response[i].type+' Bm: '+ response[i].broadcast_month +')</option>';
                    $('#invoices').html(html).multiSelect('refresh');
                    hide_loader();
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);
                }
            });
        }
    });

    $('#form_submit_com_edit').on('click', function () {
        var market_code= $('#market option:selected').val();
        if($('#name').val() !='') {
            if (typeof market_code !== 'undefined' && market_code != '') {
                var invoices = $('#invoices').val().length;
                if (invoices > 0) {
                    if($('#data_stream').val().length==0)
                        global_notification('warning', 'Please select a Data Stream...');
                    else if($('#year').val().length==0)
                        global_notification('warning', 'Please select a Year...');
                    else if($('#book_type').val().length==0)
                        global_notification('warning', 'Please select a Book Type...');
                    else if($('#book').val().length==0)
                        global_notification('warning', 'Please select a Book ...');
                    else {
                        show_loader();
                        $('#app-form-post-edit-comscore').submit();
                    }

                } else
                    global_notification('warning', 'Please select at least one invoice...');
            } else
                global_notification('warning', 'Please select a market...');
        }
        else
            global_notification('warning', 'Report Name is required...');

    });

    $('#form_secondary_demos').select2({
        placeholder: "Select one...",
        minimumResultsForSearch: 5
    });
    $('.form_secondary_demos_div').show();

}
